<div class="contact">
    <div class="contact-title">
        <h3>Contact</h3>
    </div>
    <div class="contact-content">
        <div class="contact-content-text col-sm-12 col-md-4">
            <p>Vous souhaitez rester informé ou devenir sponsor pour la prochaine édition du Play For Good Challenge
                ?</p>
            <p>Laissez nous un message :</p>
        </div>
        <div class="contact-form col-sm-12 col-md-4">
            <form>
                <label for="inputEmail" class="form-label">Adresse e-mail</label>
                <input id="inputEmail" type="email" class="form-control">
                <label for="textarea" class="form-label">Votre message</label>
                <textarea id="textarea" class="form-control" rows="3"></textarea>
                <button type="submit" class="btn btn-dark">Envoyer</button>
            </form>
        </div>
    </div>
</div>
